import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dissatisfactions",
  "description": "",
  "published": "2007-06-19T00:00:00.000Z",
  "redirect_from": ["/blog/dissatisfactions/swizec/186"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`As much as I `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=237"
      }}>{`enjoyed`}</a>{` Kubuntu and thought it would do great as the system I do my work on, there have simply been too many wrongs with it and I am forced to, yet again, change the penguins that drive the gears in my difference machine.`}</p>
    <p>{`One such very big problem was the impossibility of making my Wacom work with Photoshop 7 or even a completely virtual version of Windows. It just wouldn't work and doing a lot of graphic artistry I can't be having that, it's a vital tool. Another is the almost impossibility of setting up a proper firewall, for some reason Kubuntu just did not start up iptables on every reboot. Crazy.`}</p>
    <p>{`Therefore I'm commencing the move back to Gentoo today, should've started it yesterday, but somehow did not. The sad fact is that it will take about three days, but at least the computer will be of no use and I'll be able to do more studying.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      